<template lang="pug">
    .tab-content(v-loader-overlay="progressTasks" v-if="deal && deal.id")
        .deal-tasks
            .deal-tasks__task(v-if="tasks && tasks.length" v-for="(task, i) in tasks" v-bind:key="i" tag="md-card" md-theme="white")
                .deal-tasks__task__top
                    router-link.name(v-bind:to="{ name: 'DealTask', params: { dealid: deal.id, taskid: task.id }}") {{ task.name }}
                .deal-tasks__task__bottom
                    .project(v-if="task.project") {{task.project.name}}
                    .responsible(v-if="task.responsible") {{ (task.responsible.fio) ? task.responsible.fio : task.responsible.name }}

                    .status(v-if="task.status_section") {{task.status_section.name}}
                    .deadline(v-if="task.deadline") {{moment(task.deadline).format('DD.MM.YYYY HH:mm')}}

        p.md-caption(v-if="typeof tasks == 'undefined' || tasks.length == 0") У заявки нет ни одной задачи
        md-button(v-bind:to="{ name: 'DealTask', params: { dealid: deal.id, taskid: 'new' } }") Добавить задачу
</template>
<script>
    import moment from "moment"
    import Properties from '@/components/Properties'
    export default {
        name: 'tasks',
        props: ['deal', 'load'],
        components: {
            Properties
        },
        data() {
            return {
                currentDealId: null,
                tasks: []
            }
        },
        computed: {
            progressTasks() {
                return this.progressObj['load-deal-tasks-card'];
            },
            progressObj() {
                return this.$store.state.progressObj;
            }
        },
        watch: {
            '$props.load'(load) {
                if (load) this.getTasks(); 
            },
            '$props.deal.id'(id) {
                if (id == this.currentDealId) return;
                this.currentDealId = id;
                this.getTasks();
            }
        },
        methods: {
            getTasks() {
                if (!this.$props.load) return;
                this.$store.commit('showProgressBar', 'load-deal-tasks-card');
                this.$store.dispatch('tasks/getTasks', {
                    filter: ['["deal_id", "=", "' + this.$props.deal.id + '"]']
                }).then(r => {
                    if (r && r.body && r.body.response) this.tasks = Object.assign([], r.body.response);
                    this.$store.commit('hideProgressBar', 'load-deal-tasks-card');
                });
            },
            listeners() {
                this.$root.$on('update-deal-tasks', (data) => {
                    if (parseInt(this.$props.deal.id) == parseInt(id)) this.getTasks();
                });
            }
        },
        created() {
            this.listeners();
        },
    }
</script>
<style lang="sass">
    .deal-tasks
        .deal-tasks__task
            box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
            padding: 10px
            margin: 0 0 10px 0
            .deal-tasks__task__top
                display: flex
                align-items: flex-start
                justify-content: flex-start
                .name
                    font-size: 14px
                    line-height: 16px
                    margin: 0 0 10px 0
            .deal-tasks__task__bottom
                display: flex
                align-items: flex-start
                justify-content: flex-start
                .project, .responsible, .status
                    max-width: 150px
                    margin: 0 10px 0 0
                    flex-shrink: 0
                    white-space: nowrap
                    overflow: hidden
                    text-overflow: ellipsis
                    padding: 2px 6px
                    font-size: 12px
                    line-height: 14px
                    border-radius: 4px
                    background-color: var(--md-theme-default-primary, #2196f3)
                    color: #fff
                .responsible
                    background-color: #dadada
                    color: #000
                .deadline
                    margin: 0 0 0 auto
                

</style>


// WEBPACK FOOTER //
// Tasks.vue?4327d246